import { Box, Card, Stack, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { Helmet } from "react-helmet-async";
import ShieldOutlinedIcon from "@mui/icons-material/ShieldOutlined";
import EventAvailableOutlinedIcon from "@mui/icons-material/EventAvailableOutlined";
import FactCheckOutlinedIcon from "@mui/icons-material/FactCheckOutlined";
import BankLogo from "../assets/Logo.png";
import RSS from "../assets/rosoftsavvy.png";
import { brand } from "../theme";

const POINTS = [
  { icon: <ShieldOutlinedIcon />, text: "Every bank insurance policy in one place" },
  { icon: <EventAvailableOutlinedIcon />, text: "See what matures and renew on time" },
  { icon: <FactCheckOutlinedIcon />, text: "Approvals before anything counts" },
];

// Frame for the signed-out pages: brand panel on the left, form card on the right
export default function AuthShell({ title, subtitle, children }) {
  return (
    <Box sx={{ minHeight: "100vh", display: "flex", bgcolor: brand.bg }}>
      <Helmet>
        <title>{title} | Risk Manager</title>
      </Helmet>
      <Box
        sx={{
          display: { xs: "none", md: "flex" },
          flexDirection: "column",
          justifyContent: "space-between",
          width: "42%",
          maxWidth: 560,
          p: 6,
          color: "#fff",
          background: `radial-gradient(900px 500px at -10% -10%, ${alpha(brand.teal, 0.28)}, transparent 60%), radial-gradient(700px 500px at 110% 110%, ${alpha(brand.green, 0.22)}, transparent 60%), linear-gradient(160deg, ${brand.slate}, ${brand.slateDark})`,
        }}
      >
        <Stack direction="row" alignItems="center" gap={1.5}>
          <Box component="img" src={BankLogo} alt="Sekyere Community Bank" sx={{ width: 44, bgcolor: "#fff", borderRadius: 2, p: 0.5 }} />
          <Typography sx={{ fontWeight: 600, opacity: 0.85 }}>Sekyere Community Bank PLC</Typography>
        </Stack>
        <Box>
          <Typography sx={{ fontSize: 36, fontWeight: 700, lineHeight: 1.15, mb: 1.5 }}>Risk Manager</Typography>
          <Typography sx={{ opacity: 0.75, mb: 4, maxWidth: 380 }}>
            Track the bank's insurance cover, premiums and renewals.
          </Typography>
          <Stack gap={2}>
            {POINTS.map((p) => (
              <Stack key={p.text} direction="row" alignItems="center" gap={1.5}>
                <Box sx={{ width: 36, height: 36, borderRadius: 2, display: "grid", placeItems: "center", bgcolor: alpha("#fff", 0.1) }}>
                  {p.icon}
                </Box>
                <Typography sx={{ opacity: 0.9 }}>{p.text}</Typography>
              </Stack>
            ))}
          </Stack>
        </Box>
        <Stack direction="row" alignItems="center" gap={1} sx={{ opacity: 0.6, fontSize: 12 }}>
          Powered by <Box component="img" src={RSS} alt="Rosoftsavvy" sx={{ width: 26, bgcolor: "#fff", borderRadius: 1, p: 0.25 }} />
        </Stack>
      </Box>

      <Box sx={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", p: 2 }}>
        <Card sx={{ width: "100%", maxWidth: 420, p: { xs: 3, sm: 4 }, boxShadow: "0 12px 40px rgba(15,27,36,0.08)" }}>
          <Stack direction="row" alignItems="center" gap={1.25} sx={{ display: { md: "none" }, mb: 3 }}>
            <Box component="img" src={BankLogo} alt="Sekyere Community Bank" sx={{ width: 36 }} />
            <Typography sx={{ fontWeight: 700 }}>Risk Manager</Typography>
          </Stack>
          <Typography variant="h5" component="h1">
            {title}
          </Typography>
          {subtitle && (
            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.75, mb: 3 }}>
              {subtitle}
            </Typography>
          )}
          {children}
        </Card>
      </Box>
    </Box>
  );
}
